<template>
  <pt-deposit-settlement  @depositSettlementListExport="depositSettlementListExport"  :areaList="areaList" :companyList="companyList" class="pt-deposit-settlement__withData"></pt-deposit-settlement>
</template>

<script>
import PtDepositSettlement from './index'
export default {
  name: 'pt-deposit-settlement__withData',
  components: {
    'pt-deposit-settlement': PtDepositSettlement
  },
  data () {
    return {
      areaList: [],
      companyList: [],
      exportLoading: false
    }
  },
  created () {
    this.getAreatList()
    this.getCompanyList()
  },
  methods: {
    // 获取地区
    getAreatList () {
      this.$store.dispatch('getBusinessArea').then(data => {
        let options = []
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.areaList = options
      })
    },
    // 获取分子公司
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        this.companyList = newArr
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    },
    // 导出订金结算列表
    depositSettlementListExport (val) {
      this.exportLoading = true
      this.$store.dispatch('depositSettlementListExport', val).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出订金结算失败')
      })
    }
  }
}
</script>
